import SimpleTextKeyValue from './SimpleTextKeyValue';

export { SimpleTextKeyValue };
